/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Cookies from 'js-cookie';
import OneTrustService from "../services/OneTrust/OneTrustService";
import OneTrustGroupEnum from "../services/OneTrust/OneTrustGroupEnum";

$(function(){
    let $bar = $('.bar');

    $bar.find('[data-close]').click(function (e) {
        let permanent = $(this).data('close');
        let bar = $(this).closest('.bar');

        if(OneTrustService.isOn(OneTrustGroupEnum.STRICTLY)) {
            Cookies.set('bar_' + bar.data('id') + '_close', 1, permanent ? {expires: 365} : {});
        }

        bar.slideUp();
        $('.header-spacer .bar').slideUp(function(){
            $(window).trigger("headerSpacer.resized");
        });

        e.preventDefault();
    });
});